import type { House, LatLng } from '../types/house'
import { deriveHouse } from '../utils/house'

// Real BAG footprint (pand 0345100002020802, Veenendaal) so the outline lines up with the aerial photo.
const footprint: LatLng[] = [
  [52.036362865430235, 5.5447686252708035],
  [52.036236112840385, 5.5446763053784514],
  [52.036217236361438, 5.5447444297065758],
  [52.036305962868013, 5.5448079198391582],
  [52.036308211805391, 5.544799795569519],
  [52.036318751935774, 5.5447617658686674],
  [52.036357039882226, 5.5447896639481016],
]

export const demoHouse: House = {
  ...deriveHouse({
    street: 'Sterrenschans',
    houseNumber: '12',
    postcode: '3905XP',
    city: 'Veenendaal',
    lat: 52.03629,
    lng: 5.54475,
    footprint,
    buildYear: 1985,
    livingArea: 111,
    units: 1,
    neighbours: 1,
    source: 'demo',
  }),
  houseType: 'hoekwoning',
}
